var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aboutMainContent"},[_c('AboutSkills'),_c('Certificate'),_vm._m(0),_c('CodeAndContact')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"downloadButton"},[_c('a',{attrs:{"href":"./SusannaSCV.pdf","target":"_blank"}},[_vm._v("Download CV...")])])
}]

export { render, staticRenderFns }